// Import Third-party Packages
import React from 'react'

// Import Components
import Box from '@material-ui/core/Box'
import Drawer from '@material-ui/core/Drawer'

class StyledDrawer extends React.PureComponent {
    render() {
        const { children, ...restProps } = this.props

        return (
            <Drawer
                { ...restProps }
            >
                <Box
                    maxWidth='340px'
                    minWidth='200px'
                    width='300px'
                    height='100%'
                    overflow='hidden'
                    display='flex'
                    flexDirection='column'
                    justifyContent='flex-start'
                    alignItems='center'
                    border='2px solid rgba(56, 64, 78, 0.8)'
                    style={{ background: 'rgba(56, 64, 78, 0.8)' }}
                >
                    { children }
                </Box>
            </Drawer>
        )
    }
}

export default StyledDrawer